import { render, staticRenderFns } from "./PageChangeAnimation.vue?vue&type=template&id=3d023be8&scoped=true&"
import script from "./PageChangeAnimation.vue?vue&type=script&lang=js&"
export * from "./PageChangeAnimation.vue?vue&type=script&lang=js&"
import style0 from "./PageChangeAnimation.vue?vue&type=style&index=0&id=3d023be8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d023be8",
  null
  
)

export default component.exports